module.exports = __webpack_public_path__ + "static/challenges-51b59f4973b11d7f97b54cae4a49583d.jpg";